import { render, staticRenderFns } from "./ConcernFocusNewsItem.vue?vue&type=template&id=78f73012&scoped=true"
import script from "./ConcernFocusNewsItem.vue?vue&type=script&lang=js"
export * from "./ConcernFocusNewsItem.vue?vue&type=script&lang=js"
import style0 from "./ConcernFocusNewsItem.vue?vue&type=style&index=0&id=78f73012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f73012",
  null
  
)

export default component.exports